import { createInstance } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
// config
import { allLangs, defaultLang } from "./config";
// languages
import en from "./en";

const i18n = createInstance();

const storedLanguage = localStorage.getItem("i18nextLng");
let initialLanguage = allLangs.some(({ value }) => value === storedLanguage) ? storedLanguage : defaultLang.value;

const initializeI18n = async () => {
  const resources = {
    en: { translations: en },
  };

  if (initialLanguage !== defaultLang.value) {
    try {
      const locale = await import(`./${initialLanguage}/index.js`);
      resources[initialLanguage] = { translations: locale.default };
    } catch {
      initialLanguage = defaultLang.value;
    }
  }

  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      partialBundledLanguages: true,
      resources,
      lng: initialLanguage,
      fallbackLng: defaultLang.value,
      debug: false,
      ns: ["translations"],
      defaultNS: "translations",
      interpolation: {
        escapeValue: false,
      },
    });

  return i18n;
};

const i18nReady = initializeI18n();

export { i18nReady };
export default i18n;
